/**
 * Regex patterns for parsing JSON blocks in chat content
 * Note: [\\s\\S] matches any character including newlines
 * The *? makes it non-greedy to avoid matching multiple blocks
 * Using _{1,2} at the start to tolerate LLM sometimes outputting single underscore
 */
export const analyticsRegex = /_{1,3}ANALYZE_JSON_START_[\s_]*([\{][\s\S]*?[\}])[\s_]*ANALYZE_JSON_END_{0,3}/gm;
export const tableRegex = /_{1,3}TABLE_JSON_START_[\s_]*([\{][\s\S]*?[\}])[\s_]*TABLE_JSON_END_{0,3}/gm;
export const sourcesRegex = /_{1,3}SOURCES_JSON_START_[\s_]*([\[\{][\s\S]*?[\}\]])[\s_]*SOURCES_JSON_END_{0,3}/gm;
